function quickCamelCaseFromSnakeCase(snakeCaseString: string) {
    return snakeCaseString.split('_').reduce((accumulated, current) => {
        // for first call, accumulated is given initial value i.e. empty string
        if (accumulated.length === 0) {
            return current;
        }
        // for subsequent calls, convert the first letter of current string to Uppercase
        return (accumulated += current[0].toUpperCase() + current.substr(1));
    }, '');
}

function quickCamelCaseFromPascalCase(pascalCaseString: string) {
    return pascalCaseString.split(' ').reduce((accumulated, current) => {
        // for first call, accumulated is given initial value i.e. empty string
        if (accumulated.length === 0) {
            return current.toLowerCase();
        }
        // for subsequent calls, convert the first letter of current string to Uppercase
        return (accumulated += current[0].toUpperCase() + current.substr(1));
    }, '');
}

function truncateAfterNChar(value: string, maxChar: number) {
    if (value.length > maxChar) {
        value = value.substr(0, maxChar) + '...';
    }
    return value;
}

export { quickCamelCaseFromSnakeCase, quickCamelCaseFromPascalCase, truncateAfterNChar };
